/**
 * Environment Modal Store
 *
 * Simple Zustand store to manage the visibility of the environment switcher modal.
 */

import { create } from 'zustand'

interface EnvironmentModalState {
  isOpen: boolean
  openModal: () => void
  closeModal: () => void
}

export const useEnvironmentModalStore = create<EnvironmentModalState>((set) => ({
  isOpen: false,
  openModal: () => set({ isOpen: true }),
  closeModal: () => set({ isOpen: false }),
}))
